import { TotalPaymentService } from './../../../modules/car-booking/services/total-payment.service';
import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  HostListener,
  OnInit,
  ChangeDetectorRef,
  ViewChildren,
  QueryList,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastType } from '@shared/enum/toast-type';
import { Policy } from '@modules/car-booking/models/hotel-result.model';
import { PropertyAmenityList } from '@modules/car-booking/models/hotel-search.model';
import { createSlug } from '@shared/utils/helper';
import { ActivatedRoute, Router } from '@angular/router';
import { BookMarkService } from '@modules/car-booking/services/bookmark/bookmark.service';
import { BookmarkControllerService } from '@soctrip/angular-bookmarks-service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { BadgeInfoService } from '@shared/services/badge-info.service';

const { BloomFilter } = require('@soctrip-common/soctrip-algorithm/dist/api.js');
@Component({
  selector: 'app-airport-service-car',
  templateUrl: './airport-service-car.component.html',
  styleUrls: ['./airport-service-car.component.scss'],
  providers: [MessageService],
})
export class AirportServiceCarComponent implements OnInit, OnChanges {
  @ViewChild('tag', { static: true }) listContainer: ElementRef;
  @ViewChild('policy', { static: true }) listPolicy: ElementRef;
  @ViewChildren('hotelPolicy') hotelPolicyElements: QueryList<ElementRef>;
  @ViewChildren('hotelName') hotelNameElements: QueryList<ElementRef>;
  @ViewChildren('hotelfacility') hotelFacilityElements: QueryList<ElementRef>;
  @ViewChildren('hotelAddress') hotelAddressElements: QueryList<ElementRef>;
  @ViewChildren('hotelDistance') hotelDistanceElements: QueryList<ElementRef>;
  @Input() item: any;
  @Input() userAtDirection: number = 0;

  public hotelPolicyArray: any;
  public hotelFacilityArray: any;
  public hotelNameArray: any;
  public hotelAddressArray: any;
  public hotelDistanceArray: any;

  public isBookmark: boolean;
  public remainingFacility: number | string;
  public hasRemainingFacility: boolean = false;
  public remainingPolicy: number | string;
  public hasRemainingPolicy: boolean = false;
  public isPrice: boolean = false;
  public isVote: boolean = false;
  public sliceFacility: string;
  public slicePolicy: string;

  private resizeTimeout: any;
  public itemTagFacility: number[] = [];
  public itemTagPolicy: number[] = [];
  public displayFacility: PropertyAmenityList[];
  public displayPolicy: Policy[] = [];

  public showScoreTooltip = false;
  public showStarTooltip = false;
  ref: DynamicDialogRef | undefined;
  listImages: string[] = [];
  baseUrl = environment.STORAGE_SERVICE_API_BASE_PATH_ID_IMAGE;
  visible: boolean;
  userCurrency: string;
  mobileView: boolean = false;
  public routeName: string;

  constructor(
    private messageService: MessageService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private bookMarkService: BookMarkService,
    private bookmarkControllerService: BookmarkControllerService,
    public dialogService: DialogService,
    private translateService: TranslateService,
    public badgeInfoService: BadgeInfoService
  ) {}

  ngOnInit(): void {
    this.userCurrency =
      JSON.parse(localStorage.getItem(environment.CURRENCY_CONVERSATION_DATA) || '')?.currency ||
      'USD';
    this.calculatePolicy();
    this.checkBookmark();
    if (window.innerWidth <= 768) {
      this.mobileView = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item'] && changes['item'].currentValue) {
      this.routeName = this.generateRouteName(this.item.route, this.userAtDirection);
    }
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  generateRouteName(route: any, userAtDirection: number): string {
    if (!route || !route.places || route.places.length === 0) {
      return this.item?.route?.name || '';
    }

    const places = route.places || [];
    const airport = places.find((place: any) => place.order === 1);
    const highestOrderPlace = places.reduce(
      (highest: any, place: any) => (place.order > (highest?.order || 0) ? place : highest),
      null
    );

    if (!airport || !highestOrderPlace) {
      return this.item?.route?.name || '';
    }

    const generateName = (first: string, second: string) => `${first} - ${second}`;
    const airportName = `${airport.name}` + (airport?.iata_code ? `(${airport.iata_code})` : '');
    const placeName = highestOrderPlace.name;

    switch (route.direction) {
      case 2: // Supports both directions
        return userAtDirection === 1
          ? generateName(placeName, airportName)
          : generateName(airportName, placeName);
      case 0: // Airport -> Place
        return generateName(airportName, placeName);
      case 1: // Place -> Airport
        return generateName(placeName, airportName);
      default: // Fallback to default name
        return this.item?.route?.name || '';
    }
  }

  public calculatePolicy() {
    this.displayPolicy.push({
      name: this.translateService.instant(
        this.item?.is_required_collateral
          ? 'SEARCH_RESULT.car_list.policy.collateral_required'
          : 'SEARCH_RESULT.car_list.policy.no_collateral'
      ),
      type: 'warning',
    });
    if (this.item.is_self_pickup) {
      this.displayPolicy.push({
        name: this.translateService.instant('SEARCH_RESULT.car_list.policy.self_pickup'),
        type: 'info',
      });
    }

    if (this.item.is_home_delivery) {
      this.displayPolicy.push({
        name: this.translateService.instant('SEARCH_RESULT.car_list.policy.home_delivery'),
        type: 'error',
      });
    }
  }

  public calculateSumItem(itemTag: number[], el: ElementRef) {
    const frameTag = el.nativeElement;
    const tags = frameTag.children;
    let sumSizeTag = 0;
    for (let index = 0; index < tags.length; index++) {
      const tag = tags[index];
      if (tag.nodeType === Node.ELEMENT_NODE) {
        const childElement = tag as HTMLElement;
        sumSizeTag += childElement.offsetWidth;
        itemTag.push(sumSizeTag);
      }
    }
  }

  isDisableBookmark = false;
  handleBookmark(event: any, id: string) {
    if (this.isDisableBookmark) {
      return;
    }
    event.stopPropagation();
    if (!this.bookMarkService.isAllow) {
      this.messageService.add({
        severity: ToastType.WARNING,
        detail: 'Please login before bookmark',
      });
    } else {
      this.isDisableBookmark = true;
      if (this.isBookmark) {
        this.bookMarkService.deleteBookmark(id).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.isBookmark = false;
              this.messageService.add({
                severity: ToastType.SUCCESS,
                detail: this.translateService.instant('toast_save_car.unsave_success', {
                  param: this.item.vehicle_info?.car_model_name
                    ? this.item.vehicle_info?.car_model_name
                    : this.translateService.instant('MANAGE_RESERVATIONS.car').toLowerCase(),
                }),
              });
            }
          },
          error: (err) => {
            console.log(err);
          },
          complete: () => {
            this.isDisableBookmark = false;
          },
        });
      } else {
        this.bookMarkService.createBookMark(id).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.isBookmark = true;
              this.messageService.add({
                severity: 'success',
                detail: this.translateService.instant('toast_save_car.save_success', {
                  param: this.item.vehicle_info?.car_model_name
                    ? this.item.vehicle_info?.car_model_name
                    : this.translateService.instant('MANAGE_RESERVATIONS.car').toLowerCase(),
                }),
                key: 'save',
              });
            }
          },
          error: (err) => {
            console.log(err);
          },
          complete: () => {
            this.isDisableBookmark = false;
          },
        });
      }
    }
  }

  getPropertyImageId(item: any) {
    return item.avatar
      ? `${this.baseUrl}/${item?.avatar.id}.webp`
      : 'assets/images/test/default-hotel.svg';
  }

  checkBookmark() {
    this.bookMarkService.apiSuccess$.subscribe({
      next: (success) => {
        if (success) {
          try {
            let bloomFilter = BloomFilter.load(this.bookMarkService.bloomFilter);
            const exists = bloomFilter.has(this.item.id);
            if (exists) {
              this.bookmarkControllerService.bookmarksObjectIdIsExistedGet(this.item.id).subscribe({
                next: (res) => {
                  if (res.data.is_existed) {
                    this.isBookmark = true;
                  }
                },
              });
            } else {
              this.isBookmark = false;
            }
          } catch (error) {
            this.isBookmark = false;
          }
        }
      },
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (
      (window.innerWidth <= 1560 && window.innerWidth >= 1280) ||
      (window.innerWidth <= 1080 && window.innerWidth >= 768) ||
      (window.innerWidth <= 768 && window.innerWidth >= 0)
    ) {
      this.isPrice = true;
    } else this.isPrice = false;
    if (window.innerWidth <= 768 && window.innerWidth >= 0) {
      this.isVote = true;
      this.mobileView = true;
    } else {
      this.isVote = false;
      this.mobileView = false;
    }
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  convertDoubleToInt(num: any) {
    return num | 0;
  }

  public formatCurrency(price: number) {
    return price?.toLocaleString('en-US');
  }

  viewDetail() {
    const queryParams = {
      ...this.route.snapshot.queryParams,
      routing_id: this.item.routing_id ?? null,
      rental_type: 'is_airport_transfer',
    };
    this.router.navigate(['/booking/car/details', this.item.id, createSlug(this.item.name)], {
      queryParams,
    });
  }
  detailLink() {
    return `/booking/car/details/${this.item.id}/${this.item.name}`;
  }
  detailParams(id: string) {
    const queryParams = { ...this.route.snapshot.queryParams };
    return queryParams;
  }
  get promotion() {
    try {
      return Math.round(
        ((this.item.original_price - this.item.price) / this.item.original_price) * 100
      );
    } catch (error) {
      return 0;
    }
  }
  openDialog() {
    this.visible = true;
  }
  closeDialog() {
    this.visible = false;
  }
  getPointRange(point: number) {
    if (point > 9) {
      return this.translateService.instant('DETAIL.SUPERB');
    } else if (point > 8) {
      return this.translateService.instant('DETAIL.EXCELLENT');
    } else if (point > 7) {
      return this.translateService.instant('DETAIL.VERY_GOOD');
    } else if (point > 6) {
      return this.translateService.instant('DETAIL.PLEASANT');
    } else {
      return this.translateService.instant('DETAIL.UNCOMFORTABLE');
    }
  }

  goToRankPage(url: string, event: MouseEvent) {
    event.stopPropagation();
    if (url && url.length > 0) {
      window.open(url, '_blank');
    }
  }
}
